import { msg } from '@lingui/core/macro';

/**
 * Подписи и классы подвкладки «Шаблоны», общие для экрана и его скелетона.
 *
 * Скелетон рисует статичный текст настоящим, а данные — плашками. Чтобы после ответа
 * ничего не сдвинулось, классы раскладки и статичные подписи берутся отсюда и там и там
 * (`.claude/docs/async-loading-states.md`, «Скелетон в слоте»). Файл лёгкий нарочно:
 * скелетон не должен тянуть мутации и модалку генерации экрана.
 */
export const MEDIA_TEMPLATES_COPY = {
  assignedLabel: msg`Набор шаблонов`,
  kindsTitle: msg`Типы медиа`,
  kindsSubtitle: msg`Картинки, которые можно сгенерировать по шаблонам набора.`,
  pickTitle: msg`Выберите набор шаблонов`,
  pickSubtitle: msg`Набор шаблонов — это группа шаблонов из медиа-менеджера. По её шаблонам турнир автоматически получит картинки расписаний, результатов и таблиц.`,
  assign: msg`Назначить`,
  change: msg`Сменить`,
  unassign: msg`Отвязать`,
  generate: msg`Сгенерировать`,
  createTemplate: msg`Создать шаблон`,
} as const;

/**
 * Кнопка действия строки типа медиа — «Сгенерировать» или «Создать шаблон»: одна ширина на обе,
 * иначе кнопки строк не выравниваются, а более широкая выглядит важнее (IMGM-1518). Ширина — с
 * запасом под длинную подпись обоих языков; `justify-center` держит подпись по центру.
 */
export const MEDIA_KIND_ACTION_CLASS = 'w-40 justify-center';

/** Поверхность блока вкладки: белая карточка на фоне страницы, как у «Этапов» и «Заявок». */
export const MEDIA_CARD_CLASS = 'bg-surfaceCard rounded-card';

/** Колонка подвкладки: карточка набора, выбор набора, типы медиа. */
export const MEDIA_TEMPLATES_COLUMN_CLASS = 'flex w-full flex-col gap-6';

/** Карточка назначенного набора: иконка, три строки текста, две кнопки. */
export const MEDIA_ASSIGNED_CARD_CLASS = `${MEDIA_CARD_CLASS} flex items-center gap-4 p-5`;

/** Плитка иконки в карточке набора — 48px. */
export const MEDIA_ASSIGNED_ICON_CLASS = 'rounded-card flex h-12 w-12 shrink-0 items-center justify-center';

/** Блок с заголовком и строками под ним: «Типы медиа», выбор набора. */
export const MEDIA_SECTION_CLASS = 'flex flex-col gap-3';

/** Список строк `UDEntityRow` — типы медиа и наборы. */
export const MEDIA_ROW_LIST_CLASS = 'flex flex-col gap-2.5';
